
export default {
    apiDebug: false,
    sysDebug: false,
    // domain: "https://k4w0d4rr.xiaomy.net/api/",
    domain: "https://blog.api.caixukang.cn/",
    hostUrl: "https://admin.caixukang.cn/",
    dingWebAppId: 'dingoay9s7qudvlo0lofvu',
    key: {
        user: "_BLOG_PC_INFO",
        token: "_BLOG_PC_TOKEN",
        wyy_token: '_BLOG_WYY_TOKEN'
    },
    wyy: {
        url: "https://blog.api.caixukang.cn/",
        uid: '605537556',
    },
    websocket: {
        url: "wss://blog.api.caixukang.cn/socket"
    }
};


// WEBPACK FOOTER //
// ./src/env/env.prod.js